import { MfaSetupKey } from '@_types/shared/Mfa';
import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const fetchMfaSetupRequest = createAction('fetchMfaSetupRequest');
export const fetchMfaSetupSuccess = createAction<MfaSetupKey>('fetchMfaSetupSuccess');
export const fetchMfaSetupFailure = createAction('fetchMfaSetupFailure');

export const fetchMfaSetup =
    () =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(fetchMfaSetupRequest());
        try {
            const { data } = await api.get<MfaSetupKey>(`admin/profile/mfa/setup`, undefined, {
                auth: 'mfa',
            });

            dispatch(fetchMfaSetupSuccess(data));
        } catch (e) {
            handleApiErrors(dispatch, fetchMfaSetupFailure, e);
        }
    };
